module.exports = __webpack_public_path__ + "1aef912b1ecda8b586475e2dea5f6bdb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-9.png
// module id = 1654
// module chunks = 0